import React, { useEffect } from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import AOS from 'aos'
import 'aos/dist/aos.css'
import educationMockup from '../../../assets/images/education_mockup.png'
import Hero from './Sections/Hero/Hero';
import IndustryChallengesAndSolutions from './Sections/IndustryChallengesAndSolutions/IndustryChallengesAndSolutions';
import IndustryTech from './Sections/IndustryTech/IndustryTech'
import AISearch from './Sections/AISearch/AISearch'
import SpecializedServices from './Sections/SpecializedServices/SpecializedServices'
import WhyChoose from './Sections/WhyChoose/WhyChoose'
import image12 from '../../../assets/images/image12.png'
import Footer from '../../../Components/Footer/Footer'
import whyChooseHealthcare from '../../../assets/images/whychoosehealthcare.png';
import Contect from '../../Home/Components/Contect'
import CaseStudies from '../../Home/Components/CaseStudies'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import FAQ from '../../../Components/FAQ/FAQ';


const Education = () => {

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });
    }, []);

    const homeContent = {
        title: "Stop Losing Students to Outdated Learning Systems",
        description: "At KoolMind, we don't just build education apps; we craft digital experiences that transform disengaged students into passionate learners and supercharge your teaching team's impact. From interactive mobile apps students can't put down to web platforms that streamline your educators' workflow, we deliver innovations that boost your enrollment and retention numbers hard.",
        image: educationMockup,
        breadcrumb: "Education",
        b: "BOOK A FREE CONSULTATION"
    }

    const industryChallengesAndSolutionsContent = {
        challengesTitle: "Industry Challenges Killing Modern Education",
        solutionsTitle: "Our Battle-Tested Solutions",
        challenges: [
            {
                title: 'Your Student Data Isn\'t as Safe as You Think',
                description: 'With cyber attacks targeting schools surging, your current protections might be vulnerabilities waiting to detonate.',
                icon: '/images/industries/healthcare/00.svg',
            },
            {
                title: 'Traditional Teaching Methods Are Failing Digital Natives',
                description: 'Those lecture-heavy approaches aren\'t just boring, they\'re crushing student motivation and driving learners away with every outdated lesson that fails to connect.',
                icon: '/images/industries/healthcare/01.svg',
            },
            {
                title: 'Remote Students Are Checking Out (And Not Coming Back)',
                description: 'If your digital learning tools feel ancient, you\'re hemorrhaging students to competitors who offer engaging online experiences.',
                icon: '/images/industries/healthcare/02.svg',
            },
            {
                title: 'Your Ed-Tech Stack Is a Disconnected Mess',
                description: 'Fragmented platforms create confusion, risking student progress and exposing you to costly inefficiencies when crucial learning data gets lost between systems.',
                icon: '/images/industries/healthcare/03.svg',
            },
        ],
        solutions: [
            {
                title: 'Military-Grade Data Protection That Actually Works',
                description: 'We deploy advanced encryption and continuous security monitoring, transforming your student data into an unbreachable vault that parents and administrators can trust completely.',
                icon: '/images/industries/healthcare/05.svg',
            },
            {
                title: 'Learning Systems Built for Today\'s Students',
                description: 'Our experts don\'t just digitize old methods, they engineer engaging experiences that blend proven pedagogy with interactive elements that make learning addictive.',
                icon: '/images/industries/healthcare/06.svg',
            },
            {
                title: 'Digital Classrooms That Keep Students Glued to Their Screens',
                description: 'We create interfaces so intuitive that any student can master them, turning passive learners into active participants.',
                icon: '/images/industries/healthcare/07.svg',
            },
            {
                title: 'One Platform That Connects Everything',
                description: 'Our integration expertise weaves your educational tools into a unified, powerful system where student data flows seamlessly, exactly when educators need it.',
                icon: '/images/industries/healthcare/08.svg',
            },
        ]
    }

    const industryTechContent = {
        mainTitle: "The Technology That's Revolutionizing Education Right Now",
        leftHeading: 'Harnessing Advanced Technologies For Education Software Development',
        leftParagraph: 'We believe that integrating breakthrough technology creates unprecedented learning opportunities and institutional efficiency. Our approach builds robust, future-proof educational software that keeps you competitive.',
        leftImage: image12,
        performanceItems: [
            {
                title: 'Artificial Intelligence',
                description: "To improve understanding and retention rates, intelligent AI tailors learning courses to each student's pace.",
                icon: '/images/industries/healthcare/09.svg',
            },
            {
                title: 'Video Streaming & Content Delivery Networks',
                description: 'Regardless of location or device, high-performance streaming ensures consistent access to crystal-clear educational content worldwide.',
                icon: '/images/industries/healthcare/011.svg',
            },
            {
                title: 'Augmented Reality (AR) and Virtual Reality (VR)',
                description: 'Immersive environment settings turn intangible ideas into real-world experiences, making difficult subjects interesting and memorable for all students.',
                icon: '/images/industries/healthcare/01.svg',
            }
        ]
    };

    const aiSearchContent = {
        mainTitle: 'Get Everything You Need in One Comprehensive Package',
        sections: [
            {
                title: 'AI-Powered Learning Assistant',
                description: 'Students require immediate assistance that is aware of their unique challenges when they encounter learning obstacles during study sessions at midnight. Our AI tutor offers individualised instruction 24/7, lowering dropout rates and boosting students\' self-esteem.',
                image: '/images/industries/education/a1.png',
                imageAlt: 'AI-Powered Learning Assistant',
                imagePosition: 'left',
                features: [
                    'Clever idea explanations that simplify difficult subjects into manageable levels that students can take',
                    'Practice questions that change in difficulty according to student performance and preferred methods of learning',
                    'Knowledge gaps are detected by automated progress tracking before they result in failing marks',
                    'Multilingual support that serves diverse student populations without creating language barriers',
                    'Study habit optimization with personalized recommendations that improve retention rates by 60%',
                    'Virtual Classroom Platform',
                ],
            },
            {
                title: 'Virtual Classroom Platform',
                description: 'Remote learning isn\'t just a backup plan, it\'s today\'s competitive necessity. Our platform makes online classes feel as engaging and interactive as traditional in-person instruction sessions.',
                image: '/images/industries/education/a2.png',
                imageAlt: 'Virtual Classroom Platform',
                imagePosition: 'right',
                features: [
                    'One-click class access that eliminates technical frustrations between students and quality education content',
                    'Secure assignment submission that gives instructors complete visibility into student work and progress patterns',
                    'HD video quality that enables clear visual demonstrations and maintains strong teacher-student connection bonds',
                    'Digital whiteboarding and screen sharing that streamlines collaborative learning and group project coordination',
                    'Real-time polling and quizzes that keep students actively engaged throughout entire lesson periods',
                    'Seamless user experience that makes students prefer virtual classes over traveling to competitor institutions',
                ],
            },
            {
                title: 'Smart Scheduling and Notifications',
                description: 'Missed classes cost students valuable learning time and institutions thousands in wasted resources. Our intelligent system transforms scheduling chaos into predictable academic success patterns.',
                image: '/images/industries/education/a3.png',
                imageAlt: 'Smart Scheduling and Notifications',
                imagePosition: 'left',
                features: [
                    '24/7 online class registration that lets students enroll when your competitors\' offices are closed',
                    'Automated reminder sequences that use strategic communication timing to cut absenteeism by up to 75%',
                    'AI-powered scheduling that maximises classroom productivity and gets rid of annoying schedule problems',
                    'Personalised reminders sent by deadline tracking while students still have time to finish assignments',
                    'Calendar integration that keeps students\' academic and personal schedules perfectly synchronized across all devices',
                    'Streamlined course flow that increases daily learning capacity without overwhelming students or extending study hours',
                ],
            },
            {
                title: 'Student Performance Dashboard',
                description: 'When you can identify learning struggles before students fail, you transform from reactive problem-solving to proactive success coaching, and students notice the difference immediately.',
                image: '/images/industries/education/a4.png',
                imageAlt: 'Student Performance Dashboard',
                imagePosition: 'right',
                features: [
                    'Continuous assessment monitoring that spots concerning trends before they become academic emergencies requiring intervention',
                    'Instant alerts for significant grade changes that let educators respond with targeted support right away',
                    'Visual progress tracking that shows students their improvement and motivates continued effort toward goals',
                    'Transparent performance updates that build trust and encourage productive student-teacher collaboration relationships',
                    'Learning analytics integration that captures comprehensive academic data without requiring manual administrative input',
                    'Actionable insights that guide instructional decisions with real-time accuracy and evidence-based recommendations',
                ],
            },
            {
                title: 'Collaborative Learning Platforms',
                description: 'Together, your pupils study more effectively than they would alone. In order to keep students motivated and successful, our collaboration tools dismantle obstacles, encourage peer relationships, and build encouraging learning communities.',
                image: '/images/industries/healthcare/real-time.png',
                imageAlt: 'Collaborative Learning Platforms',
                imagePosition: 'left',
                features: [
                    'Group project management that organizes teamwork and tracks individual contributions fairly',
                    'Peer review systems that improve critical thinking while building communication skills',
                    'Discussion forums that extend classroom conversations and deepen subject understanding',
                    'Study group formation tools that connect students with complementary strengths and schedules',
                    'Knowledge sharing features that turn student questions into learning opportunities for entire classes',
                    'Community building elements that reduce isolation and increase institutional loyalty significantly',
                ],
            },
        ],
    };

    const servicesContent = {
        title: 'Our Specialized Education Services',
        cards: [
            {
                icon: '/images/industries/healthcare/012.svg',
                title: 'AI and Machine Learning',
                description: 'Custom algorithms that adapt to your curriculum, enhancing personalized learning and administrative efficiency like magic.',
                buttonText: 'Explore More',
            },
            {
                icon: '/images/industries/healthcare/013.svg',
                title: 'Student Privacy Compliant Apps',
                description: 'Privacy-first development that exceeds every regulation, protecting student data while delivering seamless educational experiences.',
                buttonText: 'Explore More',
            },
            {
                icon: '/images/industries/healthcare/014.svg',
                title: 'Virtual Learning Platforms',
                description: 'Online education that flows naturally, with integrated assessment tools and progress tracking for flawless remote instruction.',
                buttonText: 'Explore More',
            },
            {
                icon: '/images/industries/healthcare/015.svg',
                title: 'Learning Analytics',
                description: 'Transform your data into actionable insights that reduce costs and dramatically improve student outcomes.',
                buttonText: 'Explore More',
            },
            {
                icon: '/images/industries/healthcare/016.svg',
                title: 'Adaptive Learning Systems',
                description: 'Platforms designed around your teaching philosophy, not forcing you into restrictive one-size-fits-all educational approaches.',
                buttonText: 'Explore More',
            },
        ],
    };

    const whyChooseContent = {
        title: 'Here\'s Why Smart Educators Choose Us Over the Competition',
        image: whyChooseHealthcare,
        imageAlt: 'Why Choose Us for Education Technology Solutions',
        items: [
            {
                title: 'Proven Expertise',
                desc: 'More than ten years of experience using educational technology to tackle the most difficult problems facing your institution.',
            },
            {
                title: 'Tailored Fit',
                desc: 'Not general solutions, but ones made to fit your teaching style and the needs of your students.',
            },
            {
                title: 'Rock-Solid Trust',
                desc: 'Compliance is our foundation, built into every educational solution we create.',
            },
            {
                title: 'Future-Ready Growth',
                desc: 'Technology that scales with your enrollment, never limiting your expansion.',
            },
            {
                title: 'Always On Support',
                desc: 'A dedicated team with education expertise, available when technical issues strike.',
            },
        ],
    };

    const faqContent = {
        title: "Got Questions? We've Got Answers",
        questions: [
            {
                q: "In what ways does KoolMind enhance learning outcomes and student engagement?",
                a: "To develop learning experiences that students truly enjoy, we combine analytics, gamification, immersive content, AI personalisation, and collaboration tools."
            },
            {
                q: "Are you able to integrate your solution to our current learning management system?",
                a: "Yes, we are experts at integrating LMSs seamlessly while protecting your data and enabling exciting new features."
            },
            {
                q: "Can you secure our student data?",
                a: "You bet, we use military-grade encryption, regular audits, and strict compliance to keep student information completely bulletproof."
            },
            {
                q: "Will teachers need extensive training to use your platforms? ",
                a: "Nope, our intuitive design means most educators master the basics in under an hour, with ongoing support available always."
            }
        ]
    }


    return (
        <>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <div data-aos="fade-up">
                <IndustryChallengesAndSolutions industryChallengesAndSolutionsContent={industryChallengesAndSolutionsContent} />
            </div>
            <div data-aos="fade-up">
                <IndustryTech industryTechContent={industryTechContent} />
            </div>
            <div data-aos="fade-up">
                <AISearch aiSearchContent={aiSearchContent} />
            </div>
            <div data-aos="fade-up">
                <SpecializedServices servicesContent={servicesContent} />
            </div>
            <div data-aos="fade-up">
                <WhyChoose whyChooseContent={whyChooseContent} />
            </div>
            <div data-aos="fade-up">
                <CaseStudies />
            </div>
            <div data-aos="fade-up">
                <ClientSpeak />
            </div>
            <div data-aos="fade-up">
                <GetQuote />
            </div>
            <div data-aos="fade-up">
                <Contect />
            </div>
            <FAQ faqContent={faqContent} />
            <Footer />
        </>
    )
}

export default Education